if (!customElements.get("store-gallery")) {
  class StoreGallery extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.mode = this.dataset.mode || 'carousel'; // 'carousel' or 'hover_change'
    }

    connectedCallback() {
      this.mqlMobile = window.matchMedia("(max-width: 767px)");
      this.mqlMobileListener = () => this.init();
      this.mqlMobile.addEventListener("change", this.mqlMobileListener);
      this.init();
    }

    init() {
      const isMobile = this.mqlMobile.matches;
      
      // Cleanup any existing swiper instance
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      // Hide or show appropriate sections based on mode and screen size
      const hoverContainer = this.querySelector(".store-gallery__hover-showcase");
      const carouselContainer = this.querySelector(".store-gallery__carousel");

      if (isMobile) {
        // Always show carousel on mobile
        if (hoverContainer) hoverContainer.style.display = "none";
        if (carouselContainer) carouselContainer.style.display = "block";
        this.initSwiper();
      } else {
        if (this.mode === 'hover_change') {
          if (hoverContainer) hoverContainer.style.display = "grid";
          if (carouselContainer) carouselContainer.style.display = "none";
          this.initHoverChange();
        } else {
          if (hoverContainer) hoverContainer.style.display = "none";
          if (carouselContainer) carouselContainer.style.display = "block";
          this.initSwiper();
        }
      }
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.swiper-container');
      if (!swiperContainer) return;

      const paginationEl = this.querySelector('.swiper-pagination');
      const prevEl = this.querySelector('.swiper-button-prev');
      const nextEl = this.querySelector('.swiper-button-next');

      const options = {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        speed: 600,
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true,
        } : false,
        navigation: (prevEl && nextEl) ? {
          nextEl: nextEl,
          prevEl: prevEl,
        } : false,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          }
        }
      };

      const setupSwiper = () => {
        if (window.MinimogLibs && window.MinimogLibs.Swiper) {
          this.slider = new window.MinimogLibs.Swiper(swiperContainer, options);
        } else if (typeof Swiper !== 'undefined') {
          this.slider = new Swiper(swiperContainer, options);
        }
      };

      if (window.MinimogLibs && window.MinimogLibs.Swiper) {
        setupSwiper();
      } else {
        document.addEventListener('DOMContentLoaded', setupSwiper);
      }
    }

    initHoverChange() {
      const showcaseImg = this.querySelector(".store-gallery__main-image img");
      const thumbnails = this.querySelectorAll(".store-gallery__thumbnail");

      if (!showcaseImg || thumbnails.length === 0) return;

      thumbnails.forEach((thumb) => {
        thumb.addEventListener("mouseenter", () => {
          const newSrc = thumb.dataset.largeSrc;
          const newSrcset = thumb.dataset.largeSrcset;

          if (newSrc && showcaseImg.src !== newSrc) {
            // Apply fade out transition
            showcaseImg.style.opacity = "0.5";

            setTimeout(() => {
              showcaseImg.src = newSrc;
              if (newSrcset) {
                showcaseImg.srcset = newSrcset;
              } else {
                showcaseImg.removeAttribute("srcset");
              }
              showcaseImg.style.opacity = "1";
            }, 150);

            // Update active state class on thumbnails
            thumbnails.forEach((t) => t.classList.remove("is-active"));
            thumb.classList.add("is-active");
          }
        });
      });
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy(true, true);
      }
      if (this.mqlMobile && this.mqlMobileListener) {
        this.mqlMobile.removeEventListener("change", this.mqlMobileListener);
      }
    }
  }
  customElements.define("store-gallery", StoreGallery);
}
